import { FormStore, GlobalStore } from '@roc/feature-app-core';
import { parseAddress } from '@roc/feature-utils';
import { action, makeObservable } from 'mobx';

const form = {
  fields: {
    name: {
      value: '',
      error: null,
      rule: 'required',
    },
    address: {
      value: '',
      error: null,
      rule: '',
    },
    state: { value: '', error: null, rule: '' },
    streetName: { value: '', error: null, rule: '' },
    streetNumber: { value: '', error: null, rule: '' },
    zipCode: { value: '', error: null, rule: '' },
    city: { value: '', error: null, rule: '' },
    // Initial contact captured while creating the company.
    contactName: {
      value: '',
      error: null,
      rule: 'required',
    },
    contactRole: {
      value: '',
      error: null,
      rule: '',
    },
    contactPhone: {
      value: '',
      error: null,
      rule: 'regex:/^\\d{3}-?\\d{3}-?\\d{4}$/|alpha_dash',
      message: 'Phone must be a number with the format xxx-xxx-xxxx',
    },
    contactEmail: {
      value: '',
      error: null,
      rule: 'required|email',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

/**
 * Form backing the inline "New title company" creation panel: the company name + address plus the
 * first contact. The company is not persisted here — it is held in the coordinator store and saved
 * with the loan on submit (titleAgencyId stays null so the backend creates it).
 */
export class TitleCompanyFormStore extends FormStore {
  constructor(globalStore: GlobalStore) {
    super({ ...form }, globalStore);
    makeObservable(this, {
      saveAddressField: action,
    });
  }

  saveAddressField(address: string, addressDetails, geometryDetails) {
    const parsedAddress = parseAddress(address, addressDetails, geometryDetails);
    this.onFieldChange('address', address);
    this.onFieldChange('state', parsedAddress.state);
    this.onFieldChange('streetName', parsedAddress.street);
    this.onFieldChange('streetNumber', parsedAddress.street_number);
    this.onFieldChange('zipCode', parsedAddress.zip);
    this.onFieldChange('city', parsedAddress.city);
  }
}

export default TitleCompanyFormStore;
